import axios from "axios";
import { saveGroupTypes, saveRoles } from "../store/slice/configSlice";
import { saveGroupHierarchy, saveGroupList } from "../store/slice/groupSlice";
import apiclient from ".";
import { GROUP_CHILDREN_HIERARCHY, GROUP_CHILDREN_LIST } from "./apiEndpoints";

export const getGroupTypes = async (dispatch, UNO_URL, token) => {
  try {
    const { data } = await axios.get(`${UNO_URL}/api/group/roles/list`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch(saveGroupTypes(data.data.groupTypes));
    dispatch(saveRoles(data.data.roles));
  } catch (error) {
    console.log(error);
  }
};

export const getGroupHierarchy = async (dispatch, UNO_URL, groupId) => {
  try {
    let data = await apiclient.get(`${UNO_URL}${GROUP_CHILDREN_HIERARCHY}/${groupId}`);
    dispatch(saveGroupHierarchy({ hierarchy: data }));
  } catch (error) {
    console.log(error);
  }
};

export const getGroupChildrenList = async (dispatch, UNO_URL, groupId) => {
  try {
    let data = await apiclient.get(`${UNO_URL}${GROUP_CHILDREN_LIST}/${groupId}`);
    dispatch(saveGroupList({ list: data }));
  } catch (error) {
    console.log(error);
  }
};
